var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"color":_vm.chipColor(_vm.params.value)}},[_c('i',{class:'vs-icon notranslate icon-scale material-icons'},[_vm._v(_vm._s(_vm.subscriberIcon(_vm.params.value)))])])}
var staticRenderFns = []

export { render, staticRenderFns }